<template>
  <b-badge :variant="statuses[status].color">{{
    statuses[status].text
  }}</b-badge>
</template>

<script>
export default {
  props: {
    status: {},
  },

  data: () => ({
    statuses: {
      paid: {
        text: "Pago",
        color: "success",
      },

      pending_payment: {
        text: "Pagamento pendente",
        color: "warning",
      },

      waiting_payment: {
        text: "Aguardando pagamento",
        color: "warning",
      },

      processing: {
        text: "Aguardando pagamento",
        color: "info",
      },

      canceled: {
        text: "Aguardando pagamento",
        color: "danger",
      },
    },
  }),
};
</script>
